import { render } from "./Modaldiscipline.vue?vue&type=template&id=4bce038a&scoped=true"
import script from "./Modaldiscipline.vue?vue&type=script&lang=js"
export * from "./Modaldiscipline.vue?vue&type=script&lang=js"

import "./Modaldiscipline.vue?vue&type=style&index=0&id=4bce038a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4bce038a"]])

export default __exports__